import React from "react"
import { UnityEnum } from "constants/unity"
import PropTypes from "prop-types"
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FilledInput,
} from "@mui/material"

const ALL_UNITS = Object.values(UnityEnum)
const sanitize = u => {
  if (!u) return "pa"
  return String(u).toLowerCase().trim().replace(/ud\./g, "ud")
}

const UnityDropdownMUI = ({ unity, setUnity, imDesglose, disabled, label }) => {
  const base = imDesglose ? ALL_UNITS : ALL_UNITS
  const normalized = sanitize(unity)
  const options = base
  const safeValue = options.includes(normalized) ? normalized : "pa"

  return (
    <FormControl
      fullWidth
      variant="filled"
      size="small"
      disabled={disabled}
      sx={{
        backgroundColor: "white",
        "& .MuiFilledInput-root": {
          border: "none",
          backgroundColor: "transparent",
          boxShadow: "none",
        },
        "& .MuiFilledInput-root:before": { borderBottom: "none" },
        "& .MuiFilledInput-root:after": { borderBottom: "none" },
      }}
    >
      {label && <InputLabel shrink>{label}</InputLabel>}
      <Select
        value={safeValue}
        onChange={e => setUnity(sanitize(e.target.value))}
        input={<FilledInput disableUnderline />}
        displayEmpty
      >
        {options.map(unit => (
          <MenuItem key={unit} value={unit}>
            {unit}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

UnityDropdownMUI.propTypes = {
  unity: PropTypes.string,
  setUnity: PropTypes.func.isRequired,
  imDesglose: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
}

UnityDropdownMUI.defaultProps = {
  unity: "",
  imDesglose: false,
  disabled: false,
  label: "",
}

export default UnityDropdownMUI
